module.exports = __webpack_public_path__ + "img/brand.021593a7.png";